import { sanitizer } from "../../../../common/helpers/helpers";

const purifyError = (err) => {
  if (
    typeof err === "object" &&
    !Array.isArray(err) &&
    err !== null &&
    err.hasOwnProperty("__html")
  ) {
    // eslint-disable-next-line no-underscore-dangle
    err.__html = sanitizer.sanitizeAllowHtml(err.__html);
  }
  return err;
};

export default purifyError;
